/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const SearchPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,
  /**
   * Account for items
   */
  currentAccount: PropTypes.string,
  /**
   * Items that should not appear in the list
   */
  excludedItems: PropTypes.array,
  /**
   * Function returning observable used to pull out items from
   */
  itemsFrom: PropTypes.func,
  /**
   * Function called when item is selected
   */
  onChange: PropTypes.func,
};

export default SearchPropTypes;
